import { render, staticRenderFns } from "./repairOrderList.vue?vue&type=template&id=5856d4c6&scoped=true&"
import script from "./repairOrderList.vue?vue&type=script&lang=js&"
export * from "./repairOrderList.vue?vue&type=script&lang=js&"
import style0 from "./repairOrderList.vue?vue&type=style&index=0&id=5856d4c6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5856d4c6",
  null
  
)

export default component.exports